var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment';
import { get, post } from './api';
import 'moment/locale/ru';
export const getDuration = (date) => {
    const time = moment.unix(date).locale('ru');
    const duration = moment.duration(moment().diff(time));
    const formattedDuration = moment.utc(duration.as('milliseconds')).format('mm:ss');
    return { minutes: formattedDuration.split(':')[0], seconds: formattedDuration.split(':')[1] };
};
export const loadMatches = (eventId) => __awaiter(void 0, void 0, void 0, function* () {
    if (!eventId)
        return;
    const response = yield get({ path: '/v1/events/view', params: { id: eventId } });
    // console.log('matches loadMatches', response)
    // eslint-disable-next-line consistent-return
    return response;
});
export const createMatch = (data) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield post({ path: '/v1/matches/create', data });
    return response;
});
export const loadMatch = (id) => __awaiter(void 0, void 0, void 0, function* () {
    if (!id)
        return;
    const response = yield get({ path: '/v1/matches/view', params: { id } });
    // eslint-disable-next-line consistent-return
    return response;
});
export const verifyMatchPayment = (matchId) => __awaiter(void 0, void 0, void 0, function* () {
    if (!matchId)
        return;
    const response = yield get({ path: '/v1/match-state/start', params: { matchId } });
    // eslint-disable-next-line consistent-return
    return response;
});
export const cancelAction = (matchId) => __awaiter(void 0, void 0, void 0, function* () {
    if (!matchId)
        return;
    const response = yield get({ path: '/v1/match-state/rollback', params: { matchId } });
    // eslint-disable-next-line consistent-return
    return response;
});
export const getMatchState = (matchId) => __awaiter(void 0, void 0, void 0, function* () {
    if (!matchId)
        return;
    const response = yield get({ path: '/v1/match-state/view', params: { matchId } });
    // eslint-disable-next-line consistent-return
    return response;
});
export const startIntroductionPhase = (matchId) => __awaiter(void 0, void 0, void 0, function* () {
    if (!matchId)
        return;
    const response = yield get({ path: '/v1/match-state/start-introduce-phase', params: { matchId } });
    // eslint-disable-next-line consistent-return
    return response;
});
export const setPlayersOrder = ({ matchId, data }) => __awaiter(void 0, void 0, void 0, function* () {
    if (!matchId || !data || data.length === 0)
        return;
    const response = yield post({ path: '/v1/players-in-match/set-order', params: { matchId }, data: { players: data } });
    // eslint-disable-next-line consistent-return
    return response;
});
export const addPlayersToMatch = ({ matchId, data }) => __awaiter(void 0, void 0, void 0, function* () {
    if (!matchId || !data || data.length === 0)
        return;
    const response = yield post({
        path: '/v1/players-in-match/bulk-create',
        params: { matchId },
        data: { players: data },
    });
    // eslint-disable-next-line consistent-return
    return response;
});
export const getMatchLeaders = (eventId) => __awaiter(void 0, void 0, void 0, function* () {
    if (!eventId)
        return;
    const response = yield get({ path: '/v1/events/get-leaders', params: { id: eventId } });
    // console.log('matches loadMatches', response)
    // eslint-disable-next-line consistent-return
    return response;
});
